(ns journal-app-client.views.hidden
  (:require [journal-app-client.components.logo :refer [app-logo]]
            [journal-app-client.utils.interop :as interop]
            [journal-app-client.utils.react :as react]
            [journal-app-client.components.particles :as particles]
            [re-frame.core :as rf]
            [tick.core :as t]
            [cljs.pprint :refer [pprint]]))

(defn cup-game []
  (let [[state set-state] (react/use-state {:start-time (t/now)
                                            :high-score (interop/local-storage :get-item :high-score)})
        [time-now set-time-now] (react/use-state (t/now))
        [level set-level] (react/use-state 0)
        default-level-duration 15
        levels [{:spawn-number-of-cups 5}
                {:spawn-number-of-cups 10}
                {:spawn-number-of-cups 15}
                {:spawn-number-of-cups 20}
                {:spawn-number-of-cups 25}
                {:spawn-number-of-cups 30}
                {:spawn-number-of-cups 35}
                {:spawn-number-of-cups 40}
                {:spawn-number-of-cups 50}
                {:spawn-number-of-cups 60}
                {:spawn-number-of-cups 70}
                {:spawn-number-of-cups 85}
                {:spawn-number-of-cups 100}]
        start-time (:start-time state)
        current-level (nth levels level nil)
        game-over? (or (:game-over? state) (nil? current-level))
        number-of-cups (:spawn-number-of-cups current-level)
        cup-despawn-time 5
        delay-spawn-by (if (= level 0) 5 0)
        spawn-rate (/ (- default-level-duration cup-despawn-time) number-of-cups)
        memo-positions (react/use-memo
                         (fn []
                           (reduce
                             (fn [r v]
                               (conj r {:position   [(+ 10 (rand-int 80)) (+ 10 (rand-int 80))]
                                        :display-at (t/>> time-now (t/new-duration (* 1000 (+ delay-spawn-by (* v spawn-rate))) :millis))}))
                             []
                             (range number-of-cups)))
                         #js [level start-time])
        score (reduce
                (fn [r v]
                  (+ r (:score (second v))))
                0
                (:progress state))
        showing-tutorial? (when (= level 0) (t/< time-now (t/>> start-time (t/new-duration cup-despawn-time :seconds))))
        countdown (inc (t/seconds (t/duration
                                    {:tick/beginning time-now
                                     :tick/end       (t/>> start-time (t/new-duration (* (inc level) default-level-duration) :seconds))})))
        high-score (:high-score state)
        beat-high-score? (> score high-score)
        number-of-cups-up-until-level (reduce
                                        (fn [r v]
                                          (+ r (:spawn-number-of-cups v)))
                                        0
                                        (take (inc level) levels))
        number-of-cups-tapped (reduce
                                (fn [r v]
                                  (+ r (when (:tapped? (second v)) 1)))
                                0
                                (:progress state))
        number-of-cups-missed (- number-of-cups-up-until-level number-of-cups-tapped)]
    (react/use-effect
      (fn []
        (when (and game-over? beat-high-score?)
          (set-state (assoc state :high-score score))
          (rf/dispatch [:dispatch-effect [:local-storage [:set-item :high-score score]]]))
        (interop/set-timeout
          {:id       :set-cup-game-time-now
           :callback (fn [] (set-time-now (t/now)))
           :ms       250})
        (fn []
          (interop/set-timeout
            {:id      :set-cup-game-time-now
             :action :clear})))
      #js [time-now])
    (react/use-effect
      (fn []
        (interop/set-timeout
          {:id       :set-cup-game-level
           :callback (fn [] (set-level (inc level)))
           :ms       (* 1000 default-level-duration)})
        (fn []
          (interop/set-timeout
            {:id      :set-cup-game-level
             :action :clear})))
      #js [level])
    [:<>
     [:p.subtitle
      {:style {:margin-top    "2rem"
               :text-align "center"}}
      (if game-over?
        "Game over!"
        (str "Level: " level " / " (dec (count levels)) ", Score: " score
          (when-not showing-tutorial? (str ", Countdown: " countdown))))]
     (into
       (into
         [:section.section
          {:style {:display         "flex"
                   :justify-content "center"
                   :align-items     "center"
                   :flex-direction  "column"
                   :height          "calc(100svh - 12rem)"
                   :margin-top      "1rem"
                   :border          "1px solid var(--primary-brand-color)"
                   :border-radius   "1rem"
                   :position        "relative"
                   :overflow "hidden"}}
          [:button.is-clickable.glows
           {:style {:position "absolute"
                    :top "0.5rem"
                    :right "0.5rem"
                    :border-radius "100px"}
            :on-click (fn []
                        (rf/dispatch [:open-modal :confirm
                                      {:has-footer? false
                                       :children
                                       [:div
                                        {:style {:text-align "center"}}
                                        [:h1.title
                                         "What would you like to do?"]
                                        [:div
                                         {:style {:display         "flex"
                                                  :justify-content "center"
                                                  :align-items     "center"
                                                  :gap             "0.25rem"
                                                  :flex-wrap       "wrap"}}
                                         [:button.button.is-primary
                                          {:style    {:margin    "0"
                                                      :min-width "10rem"}
                                           :on-click (fn []
                                                       (rf/dispatch [:select-view :home])
                                                       (rf/dispatch [:close-modal :confirm]))}
                                          "Exit game"]
                                         [:button.button.is-primary
                                          {:style    {:margin    "0"
                                                      :min-width "10rem"}
                                           :on-click (fn []
                                                       (rf/dispatch [:close-modal :confirm])
                                                       (set-time-now (t/now))
                                                       (set-level 0)
                                                       (set-state {:start-time (t/now)
                                                                   :high-score (:high-score state)}))}
                                          "Restart"]]]}]))}
           [:span.icon [:i.fas.fa-cog]]]
          (when showing-tutorial?
            [:h1.title.fade-in
             {:style {:text-align "center"}}
             "Tap the cups before they disappear to gain points!"])
          (when showing-tutorial?
            [:h1.title.fade-in
             {:style {:text-align "center"}}
             (str "Starting in " (- countdown 10))])
          (when game-over?
            [:h1.title.fade-in
             {:style {:text-align "center"}}
             (if beat-high-score?
               "New high score!"
               "Your total score is")])
          (when game-over?
            [:h1.title.fade-in
             {:style {:text-align "center"
                      :font-size  "5rem"
                      :color      "var(--primary-brand-color)"}}
             score])
          (when (and high-score game-over?)
            [:p.subtitle.fade-in
             {:style {:text-align "center"}}
             (str (if beat-high-score?
                    "Previous high score was "
                    "Your high score is ")
               high-score)])
          (when (and (> number-of-cups-missed 0) game-over?)
            [:p.subtitle.fade-in
             {:style {:text-align "center"}}
             (str "Cups missed: "
               number-of-cups-missed)])
          (when game-over?
            [:div
             {:style {:display "flex"
                      :justify-content "center"
                      :align-items "center"
                      :gap "0.25rem"
                      :flex-wrap "wrap"}}
             [:button.button.is-primary
              {:style {:margin "0"
                       :min-width "10rem"}
               :on-click #(rf/dispatch [:select-view :home])}
              "Exit game"]
             [:button.button.is-primary
              {:style {:margin "0"
                       :min-width "10rem"}
               :on-click (fn []
                           (set-time-now (t/now))
                           (set-level 0)
                           (set-state {:start-time (t/now)
                                       :high-score (:high-score state)}))}
              "Play again"]])]
         (map
           (fn [particle-info]
             (let [key (str "particles-" (first particle-info))
                   position (:position (second particle-info))
                   ts (:ts (second particle-info))
                   visible? (and ts (t/<= time-now (t/>> ts (t/new-duration 4 :seconds))) (not game-over?))]
               (when visible?
                 [particles/main
                  {:key                       key
                   :particle-key              key
                   :animation-iteration-count 1
                   :min-speed                 250
                   :max-speed                 750
                   :delay                     0
                   :end-x-unit "vmin"
                   :end-y-unit "vmin"
                   :end-x-max 50
                   :end-y-max 50
                   :style                     {:position "absolute"
                                               :left                     (str (first position) "%")
                                               :top                      (str (second position) "%")
                                               :transform "translate(-50%, -50%)"}}])))
           (:particles state)))
       (map-indexed
         (fn [index {:keys [position display-at]}]
           (let [key (str level "-cup-" index)
                 tapped? (get-in state [:progress key :tapped?])]
             (when (and (t/>= time-now display-at) (not tapped?))
               [:div.scale-out-center
                {:key      key
                 :style    {:position                 "absolute"
                            :left                     (str (first position) "%")
                            :top                      (str (second position) "%")
                            :transform "translate(-50%, -50%)"
                            "--scale-in-scale-from"   1
                            "--scale-in-scale-to"     0
                            "--scale-in-opacity-from" 1
                            "--scale-in-opacity-to"   0
                            :animation                (str "scale-out-center " cup-despawn-time "s linear both")}
                 :on-click #(when-not tapped?
                              (let [now (t/now)]
                                (set-state (-> (assoc-in state [:progress key :score]
                                                 (+ (get-in state [:progress key :score] 0)
                                                   (Math/round (/ (t/millis
                                                                    (t/duration
                                                                      {:tick/beginning now
                                                                       :tick/end       (t/>> display-at (t/new-duration cup-despawn-time :seconds))}))
                                                                 100))))
                                             (assoc-in [:progress key :tapped?] true)
                                             (assoc-in [:particles key :position] position)
                                             (assoc-in [:particles key :ts] now)))))}
                [app-logo {:style {:height    "10vmin"
                                   :width     "10vmin"
                                   :animation "spin-initial-loader 2s linear infinite"}}]])))
         memo-positions))]))

(defn view []
  [:f> cup-game])